import { Pipe, PipeTransform } from '@angular/core';

import { Color } from '@proto/store/api/common/common';

@Pipe({ name: 'colorWithBorder', standalone: true })
export class ColorWithBorder implements PipeTransform {
  transform(color: Color | undefined): string {
    const hex = color?.hex;
    if (!hex) {
      return 'transparent';
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const solidLightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return solidLightness > 0.9 ? 'var(--border)' : 'transparent';
  }
}
